import { render, staticRenderFns } from "./PT440Favourite.vue?vue&type=template&id=15ba6e5d&"
import script from "./PT440Favourite.vue?vue&type=script&lang=js&"
export * from "./PT440Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports